<template>
  <span class="">
    OTHERS SEE - {{ session.name }}
    {{ formatOdds(-props.odds, props.league, props.sideType, true) }}
    <informational-tooltip
      v-if="user.viewOddsWithCommission"
      text-content="odds as seen by users with view odds with commission setting on"
    />
  </span>
</template>

<script setup>
import { formatOdds } from '@/core/oddsFormatUtils';
import InformationalTooltip from '@/components/global/tooltips/InformationalTooltip.vue';
import { useUserStore } from '@/stores/user';

const { user } = useUserStore();

const props = defineProps({
  odds: {
    type: Number,
    required: true,
  },
  session: {
    type: Object,
    required: true,
  },
  league: {
    type: String,
    required: false,
    default: '',
  },
  sideType: {
    type: String,
    required: false,
    default: '',
  },
});
</script>

<style scoped lang="scss">
@use '@/scss/theme/variables.scss' as theme;

.win {
  color: theme.$color-primary;
  font-size: theme.$font-size-xs;
}
</style>
